export { default as DSOLayout } from './DSOLayout';
export * as S from './DSOLayout.styles';
